import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
//  isLoading =true;
// title = 'title';
// loader = true;
// ngOnInit(): void {
//   setTimeout(()=>{                           
//     this.isLoading = false;
// }, 1200);
// }

ngOnInit() {
 // this.resetAtMidnight();
}

//  resetAtMidnight() {
//   var now = new Date();
//   var night = new Date(
//       now.getFullYear(),
//       now.getMonth(),
//       now.getDate() + 1, // the next day, ...
//       0, 0, 0 // ...at 00:00:00 hours
//   );
//   var msToMidnight = night.getTime() - now.getTime();

//   setTimeout(function() {
//     localStorage.clear();   //      <-- This is the function being called at midnight.
//      alert("by");
//      this.reset();
//     this.resetAtMidnight();  //      Then, reset again next midnight.
//   }, msToMidnight);
// }
  
//   msToUTCMidnight(){
//   const d = new Date, z = d.getTimezoneOffset();
//   d.setDate(d.getDate()+1); d.setHours(0); d.setSeconds(0); 
//   d.setMilliseconds(0); d.setMinutes(0+z);
//   return d.getTime()-Date.now();
// }
//  result = msToUTCMidnight();
// console.log(result);
// // show Client time at midnight UTC
// console.log(new Date(Date.now()+result).toString());

}

